import emailjs from 'emailjs-com';

const SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID;
const TEMPLATE_ID = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
const USER_ID = process.env.REACT_APP_EMAILJS_USER_ID;

export const sendAgreementEmail = async ({ to_email, cc_email, customer_name, pdf_url }) => {
  const templateParams = {
    to_email,
    cc_email,
    customer_name,
    message: `Dear ${customer_name},\n\nPlease find attached your rental agreement.\n\nThank you for choosing us!`,
    pdf_url,
  };

  await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, USER_ID);
};
